<template>
  <div>
    <img :src="url" alt="logo" :height="height">
  </div>
</template>

<script>

export default {
  mounted() {
    if(this.type == 'light') {
      this.url = `${this.url}/logo-light.png`
    } else if (this.type == 'dark') {
      this.url = `${this.url}/logo-dark.png`
    } else {
      this.url = `${this.url}/logo.svg`
    }
  },

  data() {
    return {
      url: process.env.VUE_APP_API_URL
    };
  },

  props: {
    height: {
      default() {
        return 80
      }
    },
    
    type: {
      default() {
        return 'default'
      }
    }
  }
};
</script>
